/** A page the member's role doesn't open: said plainly, with who can change it, instead of an error. */
import type { ReactNode } from "react";
import { Card, Empty, PageHeader } from "../kit/ui";
import { useMe } from "./context";

export function Locked({ title, what }: { title: string; what: string }) {
  const me = useMe();
  return (
    <div className="page">
      <PageHeader title={title} />
      <Card className="fill">
        <Empty icon="lock-closed" title={`${title} isn't open to your role`}>
          Your role, {me.role.label}, doesn't include {what}. An owner or admin of {me.partner.name} can change your role in Team.
        </Empty>
      </Card>
    </div>
  );
}

/** Shows the page when `allowed`, the locked state otherwise. */
export function Guard({ allowed, title, what, children }: { allowed: boolean; title: string; what: string; children: ReactNode }) {
  return allowed ? <>{children}</> : <Locked title={title} what={what} />;
}
